import { render, staticRenderFns } from "./addDefectsModal.vue?vue&type=template&id=42539415&"
import script from "./addDefectsModal.vue?vue&type=script&lang=js&"
export * from "./addDefectsModal.vue?vue&type=script&lang=js&"
import style0 from "./addDefectsModal.vue?vue&type=style&index=0&id=42539415&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports